var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrance03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.65 282.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .france-1 {\n        fill: #ef303e;\n      }\n\n      .france-2 {\n        fill: #fff;\n      }\n\n      .france-3 {\n        fill: #002153;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "france-3",
    d: "M94.22,8.04v266.57C39.33,255.21,0,202.86,0,141.33S39.33,27.44,94.22,8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "france-2",
    d: "M188.44,8.04v266.57c-14.74,5.21-30.59,8.04-47.11,8.04s-32.37-2.83-47.11-8.04V8.04C108.96,2.83,124.81,0,141.33,0s32.38,2.83,47.11,8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "france-1",
    d: "M282.65,141.33c0,61.53-39.32,113.88-94.22,133.28V8.04c54.89,19.4,94.22,71.75,94.22,133.28Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance03);
export default __webpack_public_path__ + "static/media/France-03.515c7a25b8e0e89536f9df74dbd156c2.svg";
export { ForwardRef as ReactComponent };